import {
  AnchorHTMLAttributes,
  ComponentClass,
  createElement,
  forwardRef,
  FunctionComponent,
  NamedExoticComponent,
  ReactNode
} from "react";
import classNames from "classnames";
import { RefType } from "../../../types";
import { genericMemo } from "../../../utils";

import { ReactComponent as HomeIcon } from "./icons/HomeIcon.svg";

import styles from "./styles.module.scss";

export type BaseTabHeaderProps<P = AnchorHTMLAttributes<HTMLAnchorElement>, R extends unknown = HTMLAnchorElement> = {
  ref?: RefType<R>,
  type?: "text" | "brand" | "gray"
  isHome?: boolean
  current?: boolean
  children?: ReactNode,
  className?: string,
  component?: string | FunctionComponent<P> | ComponentClass<P, any> | NamedExoticComponent<P>,
}

export type BreadcrumbBaseProps<P = AnchorHTMLAttributes<HTMLAnchorElement>, R extends unknown = HTMLAnchorElement> =
  BaseTabHeaderProps<P, R> & P;

const BreadcrumbBaseComponent = <P = AnchorHTMLAttributes<HTMLAnchorElement>, R extends unknown = HTMLAnchorElement>(props: BreadcrumbBaseProps<P, R>) => <></>;
type BreadcrumbBaseComponentType = typeof BreadcrumbBaseComponent;

export const BreadcrumbBase = genericMemo(forwardRef(<P = AnchorHTMLAttributes<HTMLAnchorElement>, R extends unknown = HTMLAnchorElement>(
  {
    type = "brand",
    isHome,
    component = "a",
    className,
    children,
    current = false,
    ...props
  }: BreadcrumbBaseProps<P, R>,
  ref: RefType<R>,
) => {

  return createElement(component as any, {
    ref,
    className: classNames(
      className,
      styles.root,
      styles[type as keyof typeof styles],
      {
        [styles.current]: current,
        [styles.withIcon]: isHome,
      },
    ),
    children: <>
      {isHome ? <HomeIcon /> : children}
    </>,
    ...props,
  });
}) as BreadcrumbBaseComponentType);
